@import "~/styles/variables";

.LoadingIcon {
  @include spin();
  border: 2px rgba($color-charcoal-dark, 0.25) solid;
  border-radius: 50%;
  border-top-color: $color-charcoal-dark;
  height: $space-m;
  width: $space-m;

  &.darkMode {
    border-color: rgba($color-white, 0.25);
    border-top-color: $color-white;
  }
}
